<template>
    <div>
        <div>
            <vue-headful :title="$t('title_dashboard')" description="title" />
            <OnBoardingContent />
        </div>
        <v-container fluid fill-height>
            <v-row class="ma-12">
                <TopBar />
                <AssignedBook />
                <CentralSection />
                <v-row justify="center" justify-lg="space-between" class="mt-6">
                    <SuperRecommended />
                    <Ranking />
                </v-row>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import AssignedBook from '@/components/home/AssignedBook.vue'
import CentralSection from '@/components/home/CentralSection.vue'
import Ranking from '@/components/home/Ranking.vue'
import SuperRecommended from '@/components/home/SuperRecommended.vue'
import TopBar from '@/components/home/TopBar.vue'
import OnBoardingContent from '@/components/onBoarding/OnBoardingContent.vue'

export default {
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
        }),
    },
    components: {
        AssignedBook,
        CentralSection,
        Ranking,
        SuperRecommended,
        TopBar,
        OnBoardingContent,
    },
}
</script>
